import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = null

const assignedDriverSlice = createSlice({
  name: 'assignedDriver',
  initialState,
  reducers: {
    changeAssignDriver: (state: any, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: () => {},
})

export const assignedDriverActionsCreator = assignedDriverSlice.actions

export default assignedDriverSlice
